import React from 'react';
import { useTranslation } from 'react-i18next';

const LanguageSwitcher = ({ className = '' }) => {
    const { i18n } = useTranslation();

    const toggleLanguage = () => {
        const newLang = i18n.language === 'fr' ? 'en' : 'fr';
        i18n.changeLanguage(newLang);
        localStorage.setItem('language', newLang);
    };

    return (
        <button
            onClick={toggleLanguage}
            className={`flex items-center gap-2 px-3 py-2 bg-slate-700/50 hover:bg-slate-600/50 border border-slate-600/50 rounded-xl text-sm font-medium transition-all duration-200 ${className}`}
            title={i18n.language === 'fr' ? 'Switch to English' : 'Passer en Français'}
        >
            <span className="text-lg">
                {i18n.language === 'fr' ? '🇫🇷' : '🇬🇧'}
            </span>
            <span className="text-slate-300 hidden sm:inline">
                {i18n.language === 'fr' ? 'FR' : 'EN'}
            </span>
        </button>
    );
};

export default LanguageSwitcher;
